import React, { useEffect, useState } from 'react';
import { useTheme } from '../context/ThemeContext';
const CustomCursor: React.FC = () => {
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const {
    theme
  } = useTheme();
  useEffect(() => {
    const updatePosition = (e: MouseEvent) => {
      setPosition({
        x: e.clientX,
        y: e.clientY
      });
    };
    window.addEventListener('mousemove', updatePosition);
    return () => {
      window.removeEventListener('mousemove', updatePosition);
    };
  }, []);
  return <div className="fixed w-4 h-4 rounded-full pointer-events-none z-50 transition-transform duration-100 ease-out" style={{
    backgroundColor: '#39FF14',
    transform: `translate(${position.x - 8}px, ${position.y - 8}px)`,
    mixBlendMode: 'difference'
  }} data-id="element-17" />;
};
export default CustomCursor;